module.exports = "/images/check-icon.svg?8ee737764f770561893f8137a4c0be64";